export default __webpack_public_path__ + "static/media/image00043.50f339eb.jpeg";